// Mobx
import { observer } from 'mobx-react'

// Components
import { BaseTableBody, BaseUploaderInline } from 'components'

// Antd
import { ColumnsType } from 'antd/es/table'

// i18n
import { useTranslation } from 'react-i18next'

// Interfaces
import { ISharedSupportDocumentTableNewProps } from './interfaces'
import { ISharedSupportDocumentNew } from 'interfaces/shared'

const SharedSupportDocumentTableNew = observer(({ data, loading, onDownload }: ISharedSupportDocumentTableNewProps) => {
  // Hook
  const { t } = useTranslation()

  // Common State
  const columns: ColumnsType<ISharedSupportDocumentNew> = [
    {
      key: 'preconditionTypeName',
      title: t('myDocument.table.jenisPrasyarat'),
      dataIndex: 'preconditionTypeName',
    },
    {
      key: 'userOriginalFileName',
      title: '',
      dataIndex: 'userOriginalFileName',
      render: (_, record) => {
        if (record.userFileBlobId && record.userOriginalFileName) {
          return (
            <BaseUploaderInline
              originalFileName={record.userOriginalFileName}
              onDownload={() => onDownload(record.userFileBlobId!)}
              loading={record.loading?.isDownloadLoading}
              isReadOnly
            />
          )
        } else {
          return ''
        }
      },
    },
  ]

  return (
    <>
      {/* Table Body */}
      <BaseTableBody
        columns={columns}
        dataSource={[...data]}
        loading={loading.isLoading}
        rowKey="id"
        pagination={false}
        className="custom-table"
        isBgPrimaryHeader
      />
    </>
  )
})

export { SharedSupportDocumentTableNew }
